import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Pain points" className="border-y border-grape-soft/30 bg-white/70" data-id="element-115" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-116" data-mp="26xmpyvom1cbd">
        <h2 className="text-center font-display text-[25px] font-black uppercase text-plum sm:text-4xl" data-id="element-117" data-mp="2bvoc5phc1rr2">
          Does this sound like you?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base font-semibold leading-relaxed text-plum" data-id="element-118" data-mp="21zurtjxdgtyq">
          You are responsible for keeping a team moving, but the daily administrative workload keeps growing.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-119" data-mp="1szg64jghxcup">
          You need to organize tasks, write updates, prepare reports, delegate responsibilities, conduct meetings, and follow up on outstanding work. Meanwhile, new priorities keep appearing.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-120" data-mp="1yz3wix84u2gb">
          Sometimes the hardest part is not knowing what needs to be done. It is knowing how to organize it all without starting from a blank page every time.
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg font-bold text-plum" data-id="element-121" data-mp="23r54i6y9p70j">
          The problem isn’t necessarily a lack of experience. It may be the lack of a <span className="text-grape" data-id="element-122" data-mp="1g3njcu9id76j">repeatable framework</span> for everyday supervisory work.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-123" data-mp="1p2he0f3a3nhg">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape-soft/40 bg-cream p-5" data-id="element-124" data-mp="1p04n3cfjm2s9" data-mpi={i}>
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-plum text-sm" aria-hidden="true" data-id="element-125" data-mp="2vkxe4skfvuao">
                {p.emoji}
              </span>
              <div data-id="element-126" data-mp="1y6cjob2q034q">
                <h3 className="text-sm font-bold text-plum" data-id="element-127" data-mp="225tor3e8iy9d">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-128" data-mp="223qprtv3tusi">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 pb-6 text-center" data-id="element-129" data-mp="1af73tvws5auf">
          <p className="mx-auto max-w-2xl font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-130" data-mp="1agi61rakuajf">
            ✨ If these challenges sound familiar, <span className="text-grape" data-id="element-131" data-mp="1jfls9451j625">SIGMA SMART™</span> has a practical resource for you.
          </p>
        </div>
      </div>
    </section>;
}